import React from "react"
import Text from "./Text/Text"
import Content from "./Content/Content"
import BlurBackground, {
  BlurBackgroundProps,
} from "./BlurBackground/BlurBackground"
import useDeviceType from "../../../hooks/useDeviceType"
import elementSplitter from "./utils/elementSplitter"
import Section from "./Section/Section"

type WidgetRightElementProps = {
  children: React.ReactElement
  topSpace?: number | string
  topSpaceResponsive?: number | string
  gap?: number
  backgroundType?: BlurBackgroundProps["type"]
  reverseResponsive?: boolean
  id?: string
}

const WidgetRightElement = ({
  children,
  topSpace = 100,
  topSpaceResponsive,
  gap = 30,
  backgroundType,
  reverseResponsive = false,
  id,
}: WidgetRightElementProps) => {
  //
  const DeviceType = useDeviceType()

  const { headers, paragraphs, spans, svgs, components, images } =
    elementSplitter(children)

  // Decorative Text
  const decorativeText = spans[0] && (
    <Text type="medium">{spans[0].props.children}</Text>
  )
  // Main Image
  const mainImage =
    images[0] &&
    React.cloneElement(images[0] as React.ReactElement, {
      style: { ...images[0].props.style, width: "400px", borderRadius: "8px" },
    })

  return (
    <Content
      id={id}
      columns={2}
      topSpace={topSpace}
      gap={gap}
      reverseResponsive={reverseResponsive}
      topSpaceResponsive={topSpaceResponsive}
      width="100%"
    >
      <Section x="left">
        {decorativeText}
        {headers}
        {paragraphs}
        {mainImage}
        {components.slice(1)} <br />
        {DeviceType !== "mobile" && DeviceType !== "tablet" && svgs}
      </Section>

      <Section x="right" fullResponsive centerResponsive>
        {components[0]}
      </Section>

      {backgroundType && (
        <BlurBackground direction="right" type={backgroundType} />
      )}
    </Content>
  )
}

export default WidgetRightElement
